import React, { useState, useEffect, useRef } from "react";

import "./ChooseFileDialog.css"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import i18n from "src/app/shared/localization/i18n";

export enum FileType{
    Image = 0,
    File = 1,
    Location = 2,
}

interface ShareInfoDialogProps {
    onFileChoosen(file: File, type: FileType): void;
    onLocationChoosen?(location: Position): void;
}

export default function ShareInfoDialog(props: ShareInfoDialogProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
    let selectedFileType = FileType.File;


    const _onFileSelected = (e: any) => {
        if(e.target.files.length === 0) {return};
        const file = e.target.files[0] as File;
        props.onFileChoosen(file, selectedFileType);

        // Task #380 - fix for IOS files uploading
        setTimeout(() => {
            document.getElementsByClassName('input-file__hidden')[0].removeAttribute('type');
            document.getElementsByClassName('input-file__hidden')[0].removeAttribute('accept');
        }, 1000)
    }

    const urlParams = new URLSearchParams(window.location.search);
    const parentUrl = urlParams.get('parent');

    const _onLocationSelected = () => {
        if (parentUrl !== null) {
            window.addEventListener("message", receiveMessage);
            window.parent.postMessage("getGeolocation", parentUrl);
        } else {
            navigator.geolocation.getCurrentPosition(_onGetCurrentPositionSuccess);
        }
    }

    const receiveMessage = (event: any) => {
        _onGetCurrentPositionSuccess(JSON.parse(event.data));
        window.removeEventListener("message", receiveMessage);
    }

    const _onGetCurrentPositionSuccess = (location: Position) => {
        props.onLocationChoosen?.(location);
    }

    const buildFileSelector = (accept: string) => {
        const fileSelector = inputRef.current;
        if (!fileSelector) {return};
        fileSelector.setAttribute('type', 'file');
        fileSelector.setAttribute('accept', accept);
        fileSelector.onchange = _onFileSelected;
        return fileSelector;
    }

    const _onMenuChoosenHandler = (type: FileType): void => {
        selectedFileType = type;
        let accept = "";
        switch(type){
            case FileType.Location:
                _onLocationSelected();
                break;
            case FileType.Image: 
                accept = "image/jpeg, image/pjpeg, image/png, image/gif";
                buildFileSelector(accept)?.click();
                break;
            case FileType.File: 
                accept = "*";
                buildFileSelector(accept)?.click();
                break;
            
        }
        setIsMenuVisible(false);
    }

    const withoutLocation = urlParams.get("withoutLocation") === "true"; 
    const withoutAttach = urlParams.get("withoutAttach") === "true"; 

    
    return (
        <React.Fragment >
            <input ref={inputRef} className="input-file__hidden"/>
            {!withoutAttach && <Dropdown className="choose-file-dialog__container" isOpen={isMenuVisible} toggle={() => { setIsMenuVisible(!isMenuVisible)}}>
                <DropdownToggle tag="div"><img className={isMenuVisible ? "choose-file-dialog__attach-image_clicked" : "choose-file-dialog__attach-image"}></img></DropdownToggle>
                {isMenuVisible && 
                    <DropdownMenu style={{}} className="choose-file-dialog__menu">
                        <div onClick={() => {_onMenuChoosenHandler(FileType.Image)}} className="choose-file-dialog__menu-item">{i18n.t("shared.image")}</div>
                        <div onClick={() => {_onMenuChoosenHandler(FileType.File)}} className="choose-file-dialog__menu-item">{i18n.t("shared.file")}</div>
                        {!withoutLocation && <div onClick={() => {_onMenuChoosenHandler(FileType.Location)}} className="choose-file-dialog__menu-item">{i18n.t("shared.location")}</div>}
                    </DropdownMenu>
                }
            </Dropdown>}
        </React.Fragment>
    )
}